import React from 'react'

function Banner({ title, breadcrumbs }) {
  return (
    <div>
      <section className="uni-banner"> 
        <div className="container">
          <div className="uni-banner-text-area">
            <h1>{title}</h1>
            <ul>
              {breadcrumbs.map((item, index) => (
                <li key={index}>
                  {item.link ? <a href={item.link}>{item.label}</a> : item.label}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Banner